import React,{useEffect,useState} from "react";
import Select from "react-select";
import "./index.css";

const Styles = {
  control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      width: "100%",
  }),
  option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      display: "flex",
      flexDirection: "row",
      alignItems:"center"
  }),
};
const options = [
    {value:"Account management",label:"Account management"},
    {value:"Bugs",label: "Bugs"},
    {value:"Community management",label:"Community management"},
    {value:"Feature Request",label:"Feature Request"},
    {value:"Plans and pricing",label:"Plans and pricing"},
    {value:"Technical support",label:"Technical support"}
]
const SelectTicketModal = ({onOpenTicket,brands})=>{
    const [selectedOption,setOption] = useState(null);
    const [selectedBrand, setBrand] = useState(null);
    function handleChange(selected){
        setOption(selected);
    }
    function handleChangeBrand(selected){
      setBrand(selected);
    }
    return (
      <div
        className="modal fade"
        id="select_ticket_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title">Create a support ticket and chat</p>
              <button
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <Select
                      value={selectedBrand}
                      onChange={handleChangeBrand}
                      placeholder="Select Brand"
                      options={(brands || []).map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                    />
                </div>
                <div className="form-group">
                  <Select
                      options={options}
                      styles={Styles}
                      placeholder="Select your ticket type"
                      value={selectedOption}
                      onChange={handleChange}
                  />
                </div>
                <div className="row-div" style={{justifyContent:"space-around"}}>
                  <button
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!selectedOption}
                    onClick={()=>onOpenTicket(selectedOption,selectedBrand)}
                  >
                    Create ticket
                  </button>
                  <button
                    className="btn btn-orange"
                    data-dismiss="modal"
                  >
                    Create later
                  </button>
                  
                  
                </div>
               
            </div>
          </div>
        </div>
      </div>
    );
}

export default SelectTicketModal;


// WEBPACK FOOTER //
// ./src/screens/SuperSupport/SelectTicketModal.js